/**
 * @desc 修改
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.DefaultShopInfoRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/defaultShopInfo/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
